import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// Keep the calendar day and drop the time. Both callers only store a date.
const toDateOnly = (date) => {
    if (!date) {
        return null
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

// Local calendar day as YYYY-MM-DD. Empty when there is no date.
export const formatLocalYearMonthDay = (date) => {
    if (!date) {
        return ''
    }
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${date.getFullYear()}-${month}-${day}`
}

const DatePicker = ({
    label,
    helperText,
    selected,
    onChange,
    clearable,
    fullWidth,
    dateFormat
}) => {
    return (
        <ReactDatePicker
            customInput={
                <TextField
                    label={label}
                    helperText={helperText}
                    fullWidth={fullWidth}
                />
            }
            selected={selected}
            {...(dateFormat ? { dateFormat } : {})}
            isClearable={clearable}
            onChange={(date) => {
                onChange(toDateOnly(date))
            }}
        />
    )
}

DatePicker.propTypes = {
    label: PropTypes.string,
    helperText: PropTypes.string,
    selected: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.oneOf([null])
    ]),
    onChange: PropTypes.func.isRequired,
    clearable: PropTypes.bool,
    fullWidth: PropTypes.bool,
    dateFormat: PropTypes.string
}

DatePicker.defaultProps = {
    label: '',
    helperText: '',
    selected: null,
    clearable: false,
    fullWidth: false
}

export default DatePicker
